var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "./http.js";
import { _getLocale } from "../utils/locale";
const _FixturesApi = class _FixturesApi {
  // In-memory cache object
  static getFixturesByDate() {
    const abortController = new AbortController();
    return {
      call(date) {
        return axios.get(`/v5/Fixtures/date/${date}`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixturesLive() {
    const abortController = new AbortController();
    return {
      call() {
        return axios.get(`/v5/Fixtures/live`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixtureDetails() {
    const abortController = new AbortController();
    return {
      call(id) {
        return axios.get(`/v5/Fixtures/${id}`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixtureLiveContext() {
    const abortController = new AbortController();
    return {
      call(id) {
        return axios.get(`/v4/Fixtures/${id}/live-context`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixtureEvents() {
    const abortController = new AbortController();
    return {
      call(id) {
        return axios.get(`/v4/Fixtures/${id}/events`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getSeasonFixtures() {
    const abortController = new AbortController();
    return {
      async call(seasonId, isResult = false) {
        return axios.get(`/v4/Fixtures/seasons/${seasonId}`, {
          signal: abortController.signal,
          params: {
            isResult
          }
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getStageFixtures() {
    const abortController = new AbortController();
    return {
      async call(stageId, isResult = false) {
        return axios.get(`/v5/Fixtures/stages/${stageId}`, {
          signal: abortController.signal,
          params: {
            isResult
          }
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixtureStatistics() {
    const abortController = new AbortController();
    return {
      async call(id) {
        const locale = _getLocale();
        const endpoint = `/v4/Fixtures/${id}/statistics`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_FixturesApi.cache.has(cacheKey)) {
          return Promise.resolve(_FixturesApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _FixturesApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixtureLineups() {
    const abortController = new AbortController();
    return {
      async call(id) {
        const locale = _getLocale();
        const endpoint = `/v4/Fixtures/${id}/lineups`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_FixturesApi.cache.has(cacheKey)) {
          return Promise.resolve(_FixturesApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _FixturesApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getFixtureH2HData() {
    const abortController = new AbortController();
    return {
      async call({ homeId, awayId }) {
        const locale = _getLocale();
        const endpoint = `/v2/Fixtures/head-to-head/${homeId}/${awayId}`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_FixturesApi.cache.has(cacheKey)) {
          return Promise.resolve(_FixturesApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _FixturesApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getTeamFixtures() {
    const abortController = new AbortController();
    return {
      async call({ teamId, stageId, isResult = false }) {
        return axios.get(`/v2/Fixtures/teams/${teamId}`, {
          signal: abortController.signal,
          params: {
            isResult,
            stageId
          }
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getPlayerMatches() {
    const abortController = new AbortController();
    return {
      async call({ playerId, stageId, isResult = true }) {
        return axios.get(`/v5/Fixtures/players/${playerId}`, {
          signal: abortController.signal,
          params: {
            isResult,
            stageId
          }
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
};
__publicField(_FixturesApi, "cache", /* @__PURE__ */ new Map());
let FixturesApi = _FixturesApi;
var stdin_default = FixturesApi;
export {
  stdin_default as default
};
